import parsePhoneNumberFromString from 'libphonenumber-js';
import { ListingCurrencyCode } from '@/features/listings/definitions';
import { CountryCode } from 'libphonenumber-js';

export function calculateDiscountedPrice(originalPrice: number, discountPercent: number): number {
    if (!discountPercent) return originalPrice;
    const discount = (originalPrice * discountPercent) / 100;
    return originalPrice - discount;
}

export function formatPrice(price: number, locale: string = 'sk-SK') {
    return Intl.NumberFormat(locale).format(price);
}

export function formatPhoneNumber(phone: string, country: CountryCode = 'SK') {
    const phoneNumber = parsePhoneNumberFromString(phone, country);
    if (!phoneNumber) return phone;
    return phoneNumber.formatInternational();
}

export function mapCurrencyCodeToText(code: ListingCurrencyCode): string {
    switch (code) {
        case 'EUR':
            return '€';
            break;
        default:
            return '';
    }
}

export function formatPriceToShort(value: number): string {
    if (value >= 1_000_000) return `${Math.floor(value / 1_000_000)}M`;
    if (value >= 1_000) return `${Math.floor(value / 1_000)}K`;
    return `${value}`;
}
